<div
  class="chat-widget-wrapper"
  [ngClass]="{ 'chat-widget-wrapper--mobile': mobileView }"
>
  <div class="chat-widget" [ngClass]="{ fullscreen: fullscreenMode }">
    <div class="chat-widget__header">
      <div class="chat-widget__header-avatar">
        <img src="{{ personAvatar }}" (error)="onAvatarNotFound($event)" />
        <div class="chat-widget__person-channels">
          <img
            brnPopup
            [component]="channelPopupComponent"
            [appendClass]="'channel-popup'"
            [data]="clients"
            [position]="'bottom'"
            src="{{ channelIcon }}"
            class="chat-widget__current-channel"
          />
        </div>
      </div>
      <div class="chat-widget__header-user">
        <h3 class="user__name">{{ person.profile.name }}</h3>
        <p class="user__status" *ngIf="!online">
          Last seen
          <span>
            {{
              person.statistics.last_sent || person.statistics.last | timeago
            }}
            ago
          </span>
        </p>
        <p class="user__status user__status--online" *ngIf="online">Online</p>
      </div>
      <div class="chat-widget__header-controls">
        <span
          class="chat-widget__info-control"
          (click)="switchInfoMode()"
          [ngClass]="{ active: infoMode }"
        >
          <i class="material-icons"> info </i>
        </span>
        <span
          (click)="changeDialogMode()"
          class="chat-widget__mode-control"
          [ngClass]="{
            'chat-widget__mode-control--manual': !autoMode,
            'chat-widget__mode-control--auto': autoMode
          }"
        >
          <i class="material-icons"> autorenew </i>
          <i>A</i>
          <i>M</i>
        </span>
      </div>
      <span
        class="fullscreen-button"
        *ngIf="fullscreenMode"
        (click)="disableFullscreen()"
      >
        <i class="material-icons"> fullscreen_exit </i>
      </span>
    </div>
    <div
      class="chat-widget__body"
      brnChatScroll
      (loadMore)="loadMoreMessages($event)"
    >
      <brn-chat-widget-message
        *ngFor="let message of messages"
        [message]="message"
        [person]="person"
      ></brn-chat-widget-message>
    </div>
    <!-- Chat input -->
    <div class="chat-widget__input">
      <form
        class="chat-widget__input-form"
        [formGroup]="chatForm"
        (ngSubmit)="sendMessage()"
      >
        <div
          class="chat-widget__input-media"
          brnPopup
          [component]="mediaPopupComponent"
          [appendClass]="'media-popup'"
          [position]="'top'"
        >
          <i class="material-icons"> attach_file </i>
        </div>
        <input
          type="text"
          formControlName="textMessage"
          required
          class="chat-widget__input-text"
          placeholder="Type here..."
        />
        <button
          type="submit"
          class="chat-widget__input-submit"
          [disabled]="!chatForm.valid"
        >
          <i class="material-icons"> send </i>
        </button>
      </form>
      <div
        class="chat-widget__input-suggestions"
        *ngIf="suggestions && suggestions.length"
      >
        <ul>
          <li
            *ngFor="let suggestion of suggestions"
            (click)="sendSuggestion(suggestion)"
          >
            {{ suggestion.text }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="chat-widget__footer">
    <span class="fullscreen-button" (click)="enableFullscreen()">
      <i class="material-icons"> fullscreen </i>
      Enable immersive mode
    </span>
  </div>
</div>
